import type { EsAutoSuggestion } from "~/types/EsAutoSuggestion"
import { searchRepository } from '../utils/searchRepository';

import { ref } from 'vue';
import type { ProductAttr } from "~/types/SearchData";


export const useSearchStore = defineStore('search', () => {
    const discount = ['50% + discount', '40% + discount', '30% + discount', '20% + discount', '10% + discount']
    const autoSuggestionList = ref<EsAutoSuggestion[]>([])
    const searchRepo = searchRepository()
    const totalCount = ref(0)
    const map = new Map<number, string>()
    const route = useRoute()
    const router = useRouter()
    let shoudRefresh = true
    const PAGE_SIZE = 12
    const filterMapItems = ref<Record<string, any>>({})
    const pageMaxPrice = ref()
    const pageMinPrice = ref()
    const searchParams = ref<Record<string, any>>({
        page_num: 1,
        page_size: PAGE_SIZE,
    })

    function updateSearchParam(key: string, value: any) {
        if (value === null || value === '' || (Array.isArray(value) && value.length === 0)) {
            delete searchParams.value[key]
        } else {
            searchParams.value[key] = value
        }
        // Reset page_num when any other parameter changes
        if (key !== 'page_num') {
            searchParams.value.page_num = 1
        }
        updateRouteQuery()
    }

    function resetSearchParams() {
        searchParams.value = {
            page_num: 1,
            page_size: PAGE_SIZE
        }
        pageMaxPrice.value = undefined
        pageMinPrice.value = undefined
        filterMapItems.value = {}
        // updateRouteQuery()
    }
    function setSearchParam(key: string, value: any) {
        if (key !== 'searchAfter') {
            searchParams.value.page_num = 1
            delete searchParams.value['searchAfter']
            map.clear()
        }
        if (value === null || value === '' || (Array.isArray(value) && value.length === 0)) {
            if (searchParams.value[key] !== undefined) {
                delete searchParams.value[key]
                updateRouteQuery()
            }
        } else {
            searchParams.value[key] = value
            updateRouteQuery()
        }
    }

    function updateMultipleSearchParam(values: Record<string, any>) {
        searchParams.value.page_num = 1
        delete searchParams.value['searchAfter']
        map.clear()
        searchParams.value = { ...searchParams.value, ...values }
        updateRouteQuery()
    }

    function updateRouteQuery() {
        const query = { ...searchParams.value }
        Object.keys(query).forEach(key => {
            if (query[key] === null || query[key] === undefined) {
                delete query[key]
            }
        })
        shoudRefresh = false;
        router.push({ query })
    }

    function syncWithRouteQuery() {
        // resetSearchParams()
        const query = { ...route.query }
        Object.entries(query).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                searchParams.value[key] = value
            }
        })
    }
    async function searchAutoSuggestion(keyword: string) {
        const data = await searchRepo.searchAutoSuggestion(keyword)
        if (data !== null && data.code === 200) {
            autoSuggestionList.value = data.data
            return data.data
        } else {
            console.error('Failed to fetch auto suggestion list:', data?.message);
        }
    }

    watch(
        () => route.query, // Watch the query object
        (query, oldQuey) => {
            if (shoudRefresh === false) {
                shoudRefresh = true
                return
            }
            if (query.productCategoryId !== oldQuey.productCategoryId || query.keyword !== oldQuey.keyword) {
                resetSearchParams();
            }
            searchParams.value.page_num = query.page_num ? parseInt(query.page_num as string) : 1;
            if (query.keyword) {
                searchParams.value.keyword = query.keyword as string;
            }
            const hasSearchAfter = map.has(searchParams.value.page_num - 1);
            if (hasSearchAfter) {
                const value = map.get(searchParams.value.page_num - 1) ?? "";
                searchParams.value.searchAfter = value; // Update searchAfter directly
            }
            if (searchParams.value.page_num === 1 || hasSearchAfter == false) {
                searchParams.value.searchAfter = '';
            }
            syncWithRouteQuery()
        }, { deep: true })


    function setUpAttributeFilters(attributes: ProductAttr[]) {
        // if attrName is same lowercase then merge it with previous value
        // else create new entry

        
    }
    return {
        totalCount,
        map,
        discount,
        searchParams,
        PAGE_SIZE,
        filterMapItems,
        pageMinPrice,
        pageMaxPrice,
        searchAutoSuggestion,
        setSearchParam,
        updateRouteQuery,
        updateSearchParam,
        syncWithRouteQuery,
        updateMultipleSearchParam,
        setUpAttributeFilters
    }
})